/**
 * @file     rateComparison.ts
 * @purpose  English strings for the mortgage rate comparison surface.
 */
export const rateComparison = {
  eyebrow: 'Compare lenders',
  headline: 'Compare mortgage rates across lenders',
  subheadline:
    'See what each lender costs per month, over the term, and at the qualifying rate.',
  sampleTitle: 'Sample data, not live rates',
  sampleBody:
    'The lenders and rates below are made up. Nothing here is an offer of credit.',
  yourNumbers: 'Your numbers',
  price: 'Purchase price',
  downPayment: 'Down payment',
  downPercent: '{{percent}}% of the purchase price',
  downPaymentSlider: 'Down payment percentage',
  rateType: 'Rate type',
  fixed: 'Fixed',
  variable: 'Variable',
  term: 'Term',
  years: '{{value}}-year',
  amortization: 'Amortization',
  province: 'Province',
  principal: 'Mortgage amount',
  premium: 'CMHC premium added',
  qualifyingRate: 'Qualifying rate',
  qualifyingHint: 'Lenders test at {{payment}}/mo',
  unavailable: 'Rates are not available right now. Your numbers are kept.',
  lowestRate: 'Lowest rate',
  rate: 'Rate',
  monthly: 'Monthly',
  vsBest: '+{{amount}}/mo',
  termInterest: 'Interest over term',
  vsBestTotal: '+{{amount}}',
  viewOffer: 'View offer',
  searchPlaceholder: 'Address or MLS® number',
  searchHint: 'Search an active listing to price it, or enter your own numbers below.',
  clearListing: 'Change',
  beds: '{{n}} bd',
  baths: '{{n}} ba',
  priceHome: 'Price a home',
  offersHeading: '{{count}} offers, lowest rate first',
  offersSummaryFixed: '{{term}}-year fixed on {{amount}}.',
  offersSummaryVariable: '{{term}}-year variable on {{amount}}.',
  lender: 'Lender',
  tryAgain: 'Try again',
  noOffers: 'No offers for these numbers',
  noOffersBody: 'Try another term or rate type.',
  crumbHome: 'Home',
  crumbTools: 'Tools',
  crumbSelf: 'Compare mortgage rates',
  relatedTitle: 'Related tools',
  relatedCalculator: 'Mortgage calculator',
  relatedStressTest: 'Mortgage stress test',
  relatedAfford: 'What you can afford',
  relatedPreApproval: 'How to get pre-approved',
  sourceSample: 'Sample lender rates',
  sourceFeed: 'Lender rate feed',
  method: 'Monthly payments use semi-annual compounding. The qualifying rate is the greater of your rate plus {{buffer}} points or {{floor}}.',
  limits: 'An estimate for general information only, not a loan offer, pre-approval, or financial, legal, or tax advice.',
  kindBank: 'Bank',
  kindCreditUnion: 'Credit union',
  kindMonoline: 'Monoline',
  kindBrokerChannel: 'Broker channel',
} as const;
